/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 4/12/2023
 */

import { apiSlice } from '../Slices/apiSlice';

export const PriceService = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getPriceByCatHrsResIds: builder.query({
            query: (data) => `/price-tbls/total-price?catId=${data.catId}&noResId=${data.noRes}&noHrsId=${data.noHrs}`
        }),

        getAllPrice:builder.query({
            query:() => "/price-tbls",
            providesTags:['price']
        }),

        getPriceById : builder.query({
            query : (priceTBLId) => `/price-tbls/${priceTBLId}`,
            providesTags:['price']
        }),

        addPrice:builder.mutation({
            query:(priceDetails) => ({
                url : '/price-tbls',
                method:'POST',
                body:priceDetails
            }),
            invalidatesTags:['price']
        }),

        updatePrice : builder.mutation({
            query:(priceDetails) => ({
                url : `/price-tbls/${priceDetails.priceTBLId}`,
                method:'PUT',
                body:priceDetails
            }),
            invalidatesTags:['price']
        }),

        deletePrice : builder.mutation({
            query:(priceTBLId) => ({
                url  : `/price-tbls/${priceTBLId}`,
                method:'DELETE'
            }),
            invalidatesTags:['price']
        })
    })
});

export const {
    useLazyGetPriceByCatHrsResIdsQuery,
    useGetAllPriceQuery,
    useGetPriceByIdQuery,
    useAddPriceMutation,
    useUpdatePriceMutation,
    useDeletePriceMutation
} = PriceService;